import { TaxWithholdingTypes } from '@Types'
import { DistributionReasonTypes } from '../CheckTransfers/Types'
import {
  WhenToSendUnion,
  TransferFrequencyType,
  TransferRecurrencesType
} from '../../components/TransferFrequency/Types'
import { TransferFeesType } from '../../components/TransferFees/types'

export enum BeneficiaryTypes {
  AccountHolder = 'ACCOUNT-HOLDER',
  ThirdParty = 'THIRD-PARTY'
}

export enum LocationOptions {
  International = 'INTERNATIONAL',
  Domestic = 'DOMESTIC'
}

export interface WireTransferValues {
  fromAccount: string
  transferAmountDisplay: string
  transferAmountRaw: number
  totalBalanceCheckbox: boolean
  beneficiaryType: BeneficiaryTypes
  beneficiaryName: string
  beneficiaryAccountNumOrIBAN: string
  thirdPartyLocation?: LocationOptions
  thirdPartyCountry?: string
  thirdPartyCountryCode?: string
  thirdPartyAddress?: string
  thirdPartyAddressLine2?: string
  thirdPartyCity?: string
  thirdPartyState?: string
  thirdPartyZip?: string
  bankDestination?: LocationOptions
  bankRouting?: string
  bankName?: string
  bankCity?: string
  bankState?: string
  bankPostalCode?: string
  bankCountry?: string
  bankCountryCode?: string
  bankUseIntermediary?: boolean
  termsOfUse: boolean
  intermediaryName?: string
  intermediaryAccountNumber?: string
  intermediaryAddress?: string
  intermediaryCity?: string
  intermediaryState?: string
  intermediaryZip?: string
  intermediaryAddressLine2?: string
  intermediaryCountry?: string
  intermediaryCountryCode?: string
  distributionReason?: DistributionReasonTypes
  federalTaxWithholdingType: TaxWithholdingTypes
  federalTaxWithholdingAmountDisplay: string
  federalTaxWithholdingAmountRaw: number
  stateTaxWithholdingType: TaxWithholdingTypes
  stateTaxWithholdingAmountDisplay: string
  stateTaxWithholdingAmountRaw: number
  receivingInstitutionName?: string
  transferRecurrence: TransferRecurrencesType
  whenToSend: WhenToSendUnion
  transferScheduledDate: Date | string
  transferFrequency: TransferFrequencyType
  transferStartDate: Date | string
  numberOfTransfers?: number
  hasTotalDistributionError?: boolean
  fees: TransferFeesType
  optOutFormProvided?: boolean
}
